// extracted by mini-css-extract-plugin
export var AccordionChevron = "FAQ-module--AccordionChevron--d8059";
export var AccordionContent = "FAQ-module--AccordionContent--426d2";
export var AccordionContentText = "FAQ-module--AccordionContentText--981bc";
export var AccordionHeader = "FAQ-module--AccordionHeader--a1f9a";
export var AccordionItem = "FAQ-module--AccordionItem--7cab8";
export var AccordionRoot = "FAQ-module--AccordionRoot--f277e";
export var AccordionTrigger = "FAQ-module--AccordionTrigger--f849f";
export var contentDark = "FAQ-module--contentDark--7aaf4";
export var contentLight = "FAQ-module--contentLight--ae828";
export var darkChevron = "FAQ-module--darkChevron--8c98e";
export var itemDark = "FAQ-module--itemDark--d34be";
export var itemLight = "FAQ-module--itemLight--3f2ae";
export var lightChevron = "FAQ-module--lightChevron--4591a";
export var slideDown = "FAQ-module--slideDown--77a52";
export var slideUp = "FAQ-module--slideUp--19906";
export var triggerDark = "FAQ-module--triggerDark--21166";
export var triggerLight = "FAQ-module--triggerLight--7a743";
export var wrapper = "FAQ-module--wrapper--a1da5";